import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { BrowserProvider } from "ethers";

export default function SignupPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [bio, setBio] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  const [previewPic, setPreviewPic] = useState(null);
  const [castleNumber, setCastleNumber] = useState(null);
  const [walletAddress, setWalletAddress] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    autoConnectWallet();
  }, []);

  const autoConnectWallet = async () => {
    if (window.ethereum) {
      try {
        const provider = new BrowserProvider(window.ethereum);
        const accounts = await provider.send("eth_requestAccounts", []);
        setWalletAddress(accounts[0]);
      } catch (err) {
        console.error("Wallet connection failed", err);
      }
    } else {
      alert("MetaMask not detected.");
    }
  };

  const handleProfilePicUpload = (e) => {
    const file = e.target.files[0];
    setPreviewPic(file);
    setProfilePic(file); // actual file object
  };

  const uploadToIPFS = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await fetch("https://api.pinata.cloud/pinning/pinFileToIPFS", {
      method: "POST",
      headers: {
        pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
        pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_API_KEY,
      },
      body: formData,
    });

    const data = await res.json();
    return `https://gateway.pinata.cloud/ipfs/${data.IpfsHash}`;
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!username.trim()) {
      alert("Username is required!");
      return;
    }

    try {
      let profilePicURL = "";

      if (profilePic) {
        profilePicURL = await uploadToIPFS(profilePic);
      }

      const response = await fetch("/api/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          bio,
          walletAddress,
          profilePic: profilePicURL,
        }),
      });

      const data = await response.json();
      if (data.success) {
        setCastleNumber(data.profile.castleNumber);
        setIsSubmitted(true);
        navigate(`/castle/${data.profile.castleNumber}`);
      } else {
        alert(data.message || "Signup failed");
      }
    } catch (err) {
      console.error("Signup failed:", err);
      alert("Error during signup.");
    }
  };

  return (
    <div className="min-h-screen bg-brandBlack text-brandWhite flex items-center justify-center p-6">
      {isSubmitted ? (
        <div className="text-center">
          <h1 className="text-5xl font-gothic mb-4">Welcome, {username}!</h1>
          <p className="text-lg mb-4">
            Your castle has been created: <span className="text-crypticGlow">{castleNumber}ЗАМОК</span>
          </p>
          {previewPic && (
            <img
              src={URL.createObjectURL(previewPic)}
              alt="Profile Preview"
              className="w-24 h-24 rounded-full border-4 border-gray-400 mx-auto mb-4"
            />
          )}
          <p className="text-gray-300">{bio}</p>
          <a
            href={`/castle/${castleNumber}`}
            className="mt-6 p-2 bg-brandWhite text-black rounded"
          >
            Enter Your Castle
          </a>
        </div>
      ) : (
        <form
          onSubmit={handleSignup}
          className="w-full max-w-lg bg-gray-900 p-6 rounded"
        >
          <h1 className="text-4xl font-gothic text-center mb-6">Sign Up</h1>

          <div className="mb-4 text-center">
            <button
              type="button"
              onClick={autoConnectWallet}
              className="p-2 bg-brandWhite text-black rounded"
            >
              {walletAddress ? "Wallet Connected" : "Connect Wallet"}
            </button>
          </div>

          <div className="mb-4">
            <label className="block text-lg font-gothic mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              className="p-2 w-full bg-transparent border border-gray-400 rounded text-white"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-gothic mb-2">Bio</label>
            <textarea
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              placeholder="Write a short bio"
              className="p-2 w-full bg-transparent border border-gray-400 rounded text-white"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-gothic mb-2">
              Profile Picture
            </label>
            <input
              type="file"
              onChange={handleProfilePicUpload}
              className="text-gray-300"
            />
          </div>

          <button
            type="submit"
            className="w-full p-2 bg-brandWhite text-black rounded hover:bg-gray-400"
          >
            Create Castle
          </button>
        </form>
      )}
    </div>
  );
}
